<template>
    <div class="container-fluid netflix dark d-flex justify-content-center align-items-center">
      <div class="row content-block">
        <div class="col col-lg-12 offset-lg-0 col-md-12 offset-md-0 col-sm-12 offset-sm-0 col-xs-12 text-center">
          <h2>{{$locale.footer_notice.main_title[lang]}}</h2>
          <p class="lead">{{$locale.footer_notice.main_text[lang]}}</p>
          <img :src="this.img" :alt="'Netflix NPCA'">
        </div>
        <div class="bg-img">
          <imageBlur :url="this.imgBackground" :type="'img'" :alt="'Pixel Deep'"></imageBlur>
        </div>
      </div>
    </div>
</template>

<script>
import imageBlur from '../../../src/pages/components/imageBlur';
import { EventBus } from '../../../src/pages/components/eventBus.js';

export default {
    name: "footerNotice",
    components: {
      imageBlur: imageBlur
    },
    data() {
      return {
        lang: '',
        img: "/img/icon_npca.png",
        imgBackground: "/img/bg_footer.jpg",
      }
    },
    methods: {},
    mounted() {
      this.lang = this.$cookie.get('pixel-deep.com');
      EventBus.$on('lang', lang => {
        this.lang = lang;
      });
    }
}

</script>

<style lang="scss">
    .bg-img {
      z-index: -1;
      height: 100vh !important;

      img {
        width: auto !important;
        height: 100vh !important;
      }
    }

    .npca {
      width: 190px;
      height: 50px;
    }

    .netflix {
      opacity: 1;
      height: 100vh;
      max-height: 800px;
    }

</style>
